import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const images = [{
  url: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=800&q=80',
  alt: 'NAD+ supplement bottle',
  span: 'md:col-span-2'
}, {
  url: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=800&q=80',
  alt: 'Wellness lifestyle',
  span: 'md:col-span-1'
}, {
  url: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80',
  alt: 'Product detail',
  span: 'md:col-span-1'
}, {
  url: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&q=80',
  alt: 'Elegant product shot',
  span: 'md:col-span-2'
}];
export function ProductGrid() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.15
  });
  const detailsRef = useScrollAnimation({
    threshold: 0.3
  });
  return <section id="product" className="px-6 py-32 md:py-40 bg-zinc-50" data-id="element-324">
      <div className="max-w-7xl mx-auto" data-id="element-325">
        

        

        {/* Product Details */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 text-zinc-950" ref={detailsRef.ref as React.RefObject<HTMLDivElement>} data-id="element-326">
          {[{
          title: 'Formulation',
          description: '500mg NAD+ precursors per serving, optimized for maximum bioavailability and cellular uptake.'
        }, {
          title: 'Purity',
          description: 'Third-party tested for purity and potency. Free from artificial additives and unnecessary fillers.'
        }, {
          title: 'Packaging',
          description: 'Pharmaceutical-grade glass bottles with UV protection to preserve ingredient integrity.'
        }].map((detail, index) => <motion.div key={index} initial={{
          y: 30,
          opacity: 0
        }} animate={detailsRef.isVisible ? {
          y: 0,
          opacity: 1
        } : {
          y: 30,
          opacity: 0
        }} transition={{
          duration: 0.7,
          delay: index * 0.15,
          ease: 'easeOut'
        }} data-id="element-327">
              <h3 className="text-sm tracking-[0.3em] uppercase mb-4 text-zinc-600" data-id="element-328">
                {detail.title}
              </h3>
              <p className="text-lg leading-relaxed text-zinc-600" data-id="element-329">
                {detail.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}